import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';
import { X } from 'lucide-react';

export default function TipCancel() {
  return (
    <Layout>
      <div className="max-w-md mx-auto py-16 text-center" data-testid="tip-cancel-page">
        <div className="mx-auto w-16 h-16 rounded-full bg-white/5 border border-white/10 flex items-center justify-center mb-4">
          <X size={32} className="text-[#A1A1AA]" />
        </div>
        <h1 className="font-heading font-black text-white text-3xl mb-2">Tip cancelled</h1>
        <p className="text-[#A1A1AA] text-sm mb-6">No card was charged. Head back and try again whenever you want.</p>
        <Link to="/feed" className="btn-pill btn-primary" data-testid="tip-cancel-back">Back to feed</Link>
      </div>
    </Layout>
  );
}
